import {graphqlRequestHandler} from 'constants/Api';
import {IUser} from 'constants/interfaces';
import {lshGETAUTH} from 'services/LocalStorageService';
import {IContract} from '../models';
const getAuthHeader = async () => {
  const token = await lshGETAUTH()
    .then((data) => data)
    .catch(() => '');
  return {Authorization: token};
};

export async function apiGetUser(userId: string): Promise<IUser> {
  const headers = await getAuthHeader();
  const variables = {userId};
  return new Promise((resolve, reject) => {
    const query = `
            query variables($userId: ID){
              user(userId: $userId){
                id
                farmer{
                  id
                  name
                  surname
                  email
                  farm{
                      id
                      name
                      sizeHectares
                      type
                      turnover
                      province
                      latLong
                  }
                }
              }
            }`;
    graphqlRequestHandler('user', query, variables, headers)
      .then((user: IUser) => resolve(user))
      .catch((error) => reject(error));
  });
}

export async function apiGetContracts(
  farmerId: string,
): Promise<Array<IContract>> {
  const headers = await getAuthHeader();
  const variables = {farmerId};
  return new Promise((resolve, reject) => {
    const query = `
          query variables($farmerId: ID){
            getFarmProduceContracts(farmerId: $farmerId){
              id
              farmer{
                farm{
                  name
                }
              }
              produce{
                name
              }
              variety{
                name
              }
              buyer{
                name
                company{
                  name
                }
              }
              expectedPrice
              expectedPriceUnit
              contractType{
                name
              }
              deliveryPreference{
                name
              }
              deliveryTerms{
                name
              }
              hectaresPlanted
              plantedDate
              estimatedSupplyDate
              isActive
              fields{
                id
              }
              fees{
                id
                feeType{
                  id
                  feeName
                  feePercentage
                }
                amount
              }
            }
          }`;
    graphqlRequestHandler('getFarmProduceContracts', query, variables, headers)
      .then((contracts: Array<IContract>) => resolve(contracts))
      .catch((error) => reject(error));
  });
}
